import { forwardRef, useState } from "react";
import { useVideoSettings } from "../../../../contexts/videoSettings/videoSettings.hook";
import { usePrefersReducedMotion } from "../../../../contexts/prefersReducedMotion/prefersReducedMotion.hook";
import { useVideoPlayback } from "../../../../hooks/useVideoPlayback";
import useResponsive from "../../../../hooks/useResponsive";
import { PhoneSlideComponentProps } from "./PhoneSlide.types";
import ScrollIndicator from "./partials/ScrollIndicator/ScrollIndicator.component";
import { Profile } from "./partials/Profile.component";
import styles from "../../Phone.module.scss";
import { MobileVolume } from "./partials/MobileVolume.component";
import { VotingButtons } from "./partials/VotingButtons.component";

export const PhoneSlideComponent = forwardRef<
  HTMLDivElement,
  PhoneSlideComponentProps
>(({ asset, type, fallback, profileData, dataKey, isActive, index }, ref) => {
  const { isMuted } = useVideoSettings();
  const { prefersReducedMotion } = usePrefersReducedMotion();
  const { forceFallback, videoRef } = useVideoPlayback({ isActive });
  const { isMobile } = useResponsive();

  const [isMobileMuted, setIsMobileMuted] = useState<boolean>(true);

  return (
    <div ref={ref} data-slide-id={dataKey} className={styles.phoneSlide}>
      {index === 0 && <ScrollIndicator />}

      <Profile profileData={profileData} />

      {type === "image" && (
        <img
          src={asset}
          alt="slide"
          loading="lazy"
          className={styles.assetStyles}
        />
      )}

      {type === "video" && (
        <div className={styles.videoAssetWrapper}>
          {prefersReducedMotion || forceFallback ? (
            <img src={fallback} alt="" className={styles.assetStyles} />
          ) : (
            <>
              <video
                ref={videoRef}
                className={styles.assetStyles}
                autoPlay
                muted={isMobile ? isMobileMuted : isMuted}
                playsInline
                loop
                poster={fallback}
              >
                <source src={asset} type="video/mp4" />
              </video>

              {isMobile && (
                <MobileVolume
                  isMobileMuted={isMobileMuted}
                  setIsMobileMuted={setIsMobileMuted}
                />
              )}

              <VotingButtons isActive={isActive} />
            </>
          )}
        </div>
      )}
    </div>
  );
});
